import { Link } from 'react-router-dom';

interface ComicCardProps {
  slug: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  status: string;
  views: number;
  rating: number;
  updateDate: string;
}

function formatViews(views: number): string {
  if (views >= 10000) {
    return (views / 10000).toFixed(1) + '万';
  }
  return views.toString();
}

export default function ComicCard({
  slug,
  title,
  author,
  cover,
  status,
  views,
  rating,
  updateDate,
}: ComicCardProps) {
  return (
    <Link
      to={`/comic/${slug}`}
      className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          title={`${title} - 韩漫屋`}
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
            status === '连载中'
              ? 'bg-primary-500 text-white'
              : 'bg-foreground-600 text-white'
          }`}>
            {status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8">
          <div className="flex items-center gap-2 text-white text-xs">
            <span className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-star-fill text-yellow-400 text-xs"></i>
              {rating}
            </span>
            <span className="whitespace-nowrap">
              <i className="ri-eye-line mr-0.5"></i>
              {formatViews(views)}
            </span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{author}</p>
        <p className="text-xs text-foreground-400 mt-0.5 whitespace-nowrap">更新于 {updateDate}</p>
      </div>
    </Link>
  );
}